import { useState, useEffect } from "react";

const useScreenOrientation = () => {
  const [height, setHeight] = useState<number>(typeof window !== "undefined" ? window.innerHeight : 0);
  const [horizontal, setHorizontal] = useState<boolean>(window.innerWidth > window.innerHeight);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const handleResize = () => {
      setHeight(window.innerHeight);
      setHorizontal(window.innerWidth > window.innerHeight);
    };

    const handleOrientationChange = () => {
      setTimeout(() => {
        setHeight(window.innerHeight);
        setHorizontal(window.innerWidth > window.innerHeight);
      }, 100);
    };

    setHeight(window.innerHeight);
    setHorizontal(window.innerWidth > window.innerHeight);

    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", handleOrientationChange);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleOrientationChange);
    };
  }, []);

  return { height, horizontal };
};

export default useScreenOrientation;
